import { withClientState } from 'apollo-link-state';

const defaults = {
  clientError: {
    id: 'error-id',
    traceId: '',
    errorCode: '',
    __typename: 'ClientError',
  },
};

const resolvers = {
  Mutation: {
    clientError: (_, { errorCode, traceId, id }, { cache }) => {
      const data = {
        clientError: {
          errorCode,
          traceId,
          id,
          __typename: 'ClientError',
        },
      };

      cache.writeData({ data });
      return null;
    },
  },
  Query: {
    // Add queries values here
  },
};

export default function stateLink(cache) {
  return withClientState({
    cache,
    defaults,
    resolvers,
  });
}
